import { Checkbox, FormControlLabel, useTheme } from "@mui/material";
import React from "react";
import {
  CheckBoxItems,
  ColorPaletteObject,
  GeojsonAttributes,
} from "../hooks/useProjectShapeFile";

export type CheckBoxFormControlLabelProps = {
  checkBoxItems: CheckBoxItems;
  colorPalette: ColorPaletteObject;
  selectedColorOption: keyof GeojsonAttributes;
  colorOption: keyof GeojsonAttributes;
  handleCheckBoxChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  checkedOptions: CheckBoxItems;
};

export const CheckBoxFormControlLabel = React.memo(
  ({
    checkBoxItems,
    colorPalette,
    selectedColorOption,
    colorOption,
    handleCheckBoxChange,
    checkedOptions,
  }: CheckBoxFormControlLabelProps) => {
    const theme = useTheme();

    const checkBoxForm = checkBoxItems?.map((v) => {
      if (!checkedOptions) return null;

      const color =
        colorOption === selectedColorOption
          ? colorPalette?.[colorOption]?.[v]?.hex() ??
            theme.palette.primary.main
          : theme.palette.primary.main;

      const checked = checkedOptions.includes(v);

      return (
        <FormControlLabel
          key={v}
          label={v}
          control={
            <Checkbox
              sx={{
                color,
                "&.MuiCheckbox-root.Mui-checked": {
                  color,
                },
              }}
              name={v}
              onChange={handleCheckBoxChange}
              checked={checked}
            />
          }
        />
      );
    });

    return <>{checkBoxForm}</>;
  },
);

CheckBoxFormControlLabel.displayName = "CheckBoxFormControlLabel";
